import axios from 'axios';

import {
  ROOT,
  DEVICES_URL,
  LINK_URL,
  UNLINK_URL,
  SET_DEVICES,
  SET_CURRENT_DEVICE,
  SET_DEVICE_COUNT,
  UNLINK_ALL,
  PAUSE_URL,
  OFF_PAUSE_URL,
  PAUSE_STATE_URL,
  SET_META_DATA,
  META_DATA_URL,
  EXPORT_META_URL,
  SET_NEXT_DEVICE_PAGE,
  ADD_DEVICES,
} from '../../constants';
import { getPatient, setPatientPause } from './patients';

export const getDevices = (assignable = false, page = 1, pageSize = 10) => {
  return async (dispatch) => {
    const query = {};
    if (page !== -1 && pageSize !== -1) {
      query.page = page;
      query.page_size = pageSize;
    }
    if (assignable) {
      query.assignable = 1;
    }
    axios
      .get(`${ROOT}${DEVICES_URL}`, { params: query })
      .then((response) => {
        dispatch(setDevices(response.data.results));
        dispatch(setDeviceCount(response.data.count));

        if (response.data.next) {
          dispatch(setNextDevicePage(response.data.next));
        }
      })
      .catch((error) => {
        const { response } = error;
        const { data } = response;
        return { success: false, data };
      });
  };
};

export const getNextDevicePage = (queryObject) => {
  return async (dispatch) => {
    axios
      .get(`${ROOT}${DEVICES_URL}`, { params: queryObject })
      .then((response) => {
        dispatch(addDevices(response.data.results));

        if (response.data.next) {
          dispatch(setNextDevicePage(response.data.next));
        }
      })
      .catch((error) => {
        const { response } = error;
        const { data } = response;
        return { success: false, data };
      });
  };
};

export const getDevice = (id) => {
  return async (dispatch) => {
    axios
      .get(`${ROOT}${DEVICES_URL}${id}`)
      .then((response) => {
        const match = response.data;
        dispatch(setDevice(match));
      })
      .catch((error) => {
        const { response } = error;
        const { data } = response;
        return { success: false, data };
      });
  };
};

export const getDeviceMetaData = (id, page, pageSize) => {
  return async (dispatch) => {
    axios
      .get(`${ROOT}${META_DATA_URL}?mac_address=${id}&page_size=${pageSize}&page=${page}`)
      .then((response) => {
        dispatch(setMetaData(response.data.results, response.data.count));
      })
      .catch((error) => {
        return { success: false, data: error };
      });
  };
};

export const exportDeviceMetaData = (macAddress, startDate, endDate) => {
  const body = {
    mac_address: macAddress,
    start_date: startDate,
    end_date: endDate,
  };
  return axios
    .post(`${ROOT}${EXPORT_META_URL}`, body, { responseType: 'blob' })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `monitor_meta_${macAddress}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
};

export const provisionDevice = (formData) => {
  return async (dispatch) => {
    const data = { mac_address: formData.toUpperCase() };
    axios
      .post(`${ROOT}${DEVICES_URL}`, data)
      .then(() => {
        dispatch(getDevices());
      })
      .catch((error) => {
        return error;
      });
  };
};

export const linkDevice = (id, patientId) => {
  return async (dispatch) => {
    const data = { patient_id: patientId };
    axios
      .post(`${ROOT}${DEVICES_URL}${id}/${LINK_URL}`, data)
      .then(() => {
        dispatch(getPatient(patientId));
        dispatch(getDevices(true));
        dispatch(getDevice(id));
      })
      .catch((error) => {
        return error;
      });
  };
};

export const unlinkDevice = (id, patientId) => {
  return async (dispatch) => {
    axios
      .delete(`${ROOT}${DEVICES_URL}${id}/${UNLINK_URL}`)
      .then(() => {
        dispatch(getPatient(patientId));
        dispatch(getDevices(true));
        dispatch(getDevice(id));
      })
      .catch((error) => {
        return error;
      });
  };
};

export const unlinkAll = (patientId) => {
  return async (dispatch) => {
    axios
      .post(`${ROOT}${UNLINK_ALL}`, { patient: patientId })
      .then(() => {
        dispatch(getPatient(patientId));
      })
      .catch((error) => {
        return error;
      });
  };
};

export const getDevicesStatus = (deviceId1, _deviceId2) => {
  return async (dispatch) => {
    axios
      .get(`${ROOT}${PAUSE_STATE_URL}`, { params: { device_id: deviceId1 } })
      .then((response) => {
        let pause = null;
        const now = new Date();
        response.data.results.forEach((item) => {
          if (!item.end_date) pause = 0;
          const end = new Date(item.end_date);
          if (end > now) pause = item.end_date;
        });
        dispatch(setPatientPause(pause));
      })
      .catch((error) => {
        return error;
      });
  };
};

export const pauseDevices = (deviceId1, deviceId2, pauseTime) => {
  return async (dispatch) => {
    const devices = [];
    if (deviceId1 !== undefined) {
      devices.push(axios.post(`${ROOT}${DEVICES_URL}${deviceId1}/${PAUSE_URL}`, { off_pause_time: pauseTime }));
    }
    if (deviceId2 !== undefined) {
      devices.push(axios.post(`${ROOT}${DEVICES_URL}${deviceId2}/${PAUSE_URL}`, { off_pause_time: pauseTime }));
    }
    Promise.all(devices)
      .then(() => {
        dispatch(getDevicesStatus(deviceId1, deviceId2));
      })
      .catch((error) => {
        return error;
      });
  };
};

export const stopPauseDevices = (deviceId1, deviceId2) => {
  return async (dispatch) => {
    const devices = [];
    if (deviceId1 !== undefined) {
      devices.push(axios.post(`${ROOT}${DEVICES_URL}${deviceId1}/${OFF_PAUSE_URL}`));
    }
    if (deviceId2 !== undefined) {
      devices.push(axios.post(`${ROOT}${DEVICES_URL}${deviceId2}/${OFF_PAUSE_URL}`));
    }
    Promise.all(devices)
      .then(() => {
        dispatch(getDevicesStatus(deviceId1, deviceId2));
      })
      .catch((error) => {
        return error;
      });
  };
};

export const setDevice = (device) => {
  return {
    type: SET_CURRENT_DEVICE,
    device,
  };
};

export const setDevices = (devices) => {
  return {
    type: SET_DEVICES,
    devices,
  };
};

export const addDevices = (devices) => {
  return {
    type: ADD_DEVICES,
    devices,
  }
};

export const setNextDevicePage = (url) => {
  return {
    type: SET_NEXT_DEVICE_PAGE,
    url,
  };
};

export const setDeviceCount = (deviceCount) => {
  return {
    type: SET_DEVICE_COUNT,
    deviceCount,
  };
};

export const setMetaData = (metaData, metaDataPages) => {
  return {
    type: SET_META_DATA,
    metaData,
    metaDataPages,
  };
};
